import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import cx from 'classnames';
import iconClasses from './Icon.module.scss';

export default function Icon({ icon, size, color, className }) {
  const cs = cx(
    iconClasses.icon,
    {
      [iconClasses[`color-${color}`]]: color !== undefined,
    },
    className,
  );
  return <FontAwesomeIcon icon={icon} size={size} className={cs} />;
}

Icon.propTypes = {
  icon: PropTypes.any,
  size: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'grey-300',
    'grey-400',
    'accent',
    'warning',
    'error',
    'white',
  ]),
};
